import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ProductCard from '../ProductCard';

interface ProductRecomendationsProps {
  dataSet: {
    productId: number;
    baseUrl: string;
    limit: number;
    title: string;
    template: string;
  };
}

const ProductRecommendations = (props: ProductRecomendationsProps): JSX.Element => {
  const [products, setProducts] = useState([]);
  const {
    dataSet: { baseUrl, productId, limit, title, template },
  } = props;
  const desktopImageSize = template === 'apparel' ? '450x540' : '450x450';
  const desktop2xImageSize = template === 'apparel' ? '900x1080' : '900x900';
  const mobileImageSize = template === 'apparel' ? '225x270' : '225x225';

  useEffect(() => {
    axios.get(`${baseUrl}.json?product_id=${productId}&limit${2 * limit}`)
      .then((res) => {
        const d = res.data;
        if (d && d.products) {
          const filteredProduct = d.products.filter(p => p.tags.indexOf('subscription-bundle') === -1 && p.type.toLowerCase() !== 'hidden' && p.type.toLowerCase() !== 'custom bundle').slice(0, limit)
          setProducts(filteredProduct);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, [setProducts]);

  return products && products.length > 0 ? (
    <section className="product-related-products-snippet">
      <div className="container">
        <h2 className="heading-3 text-upper text-center">{title}</h2>
        <ul className="cl-product-card-container grid-list">
          {products.map((product, i) => (
            <li className="grid-item" key={`product-recommendation-${i}`}>
              <a href={product.url} title={product.title} className="cl-product-card">
                <ProductCard
                  product={product}
                  desktopImageSize={desktopImageSize}
                  desktop2xImageSize={desktop2xImageSize}
                  mobileImageSize={mobileImageSize}
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  ) : null;
};

export default ProductRecommendations;
